import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Top = {
  Wrapper: styled.div`
    width: 100%;
    height: 50rem;
    z-index: 1;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      height: 38.2rem;
    }
  `,

  Background: styled.div`
    background-color: #f0f3f8;
    width: 192rem;
    position: absolute;
    height: 50rem;
    left: -36rem;
    z-index: -1;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      width: 100vw;
      height: 38.2rem;
      left: 0;
    }
  `,

  Container: styled.div`
    display: flex;
    padding-top: 7rem;
    gap: 7.5rem;
    justify-content: space-between;
    & > img {
      width: 40rem;
      height: 40rem;
    }

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      flex-direction: column-reverse;
      padding-top: 3rem;
      gap: 0.6rem;

      & > img {
        width: 15.6rem;
        height: 15.6rem;
      }
    }
  `,
  TextWrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    padding-top: 13rem;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      gap: 1.6rem;
      padding-top: 0rem;
    }
  `,
  Title: styled.div`
    font-size: 6rem;
    font-weight: 800;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 4.8rem;
      width: 30rem;
    }
  `,
  Text: styled.div`
    font-size: 2rem;
    font-weight: 300;
    color: #777;

    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      font-size: 1.6rem;
    }
  `,
};
